export default __webpack_public_path__ + "static/media/visa.646b8e36.png";